import { usePopup } from '@contexts/popupContext';
import { Flap } from '@models/Flap';
import styles from '@styles/components/General/SingleTabScreen.module.css';
import React from 'react';
import { ReactComponent as ArrowLeftSVG } from '@assets/SVGs/Configuracion/ArrowLeft.svg';
import { useNavigate } from 'react-router-dom';

interface SingleTabScreenProps {
    title: string;
    subtitle?: string;
    flap: Flap;
    hasBackButton?: boolean;
    subtitleIsNextToTitle?: boolean;
}

const SingleTabScreen: React.FC<SingleTabScreenProps> = ({ title, subtitle, flap, hasBackButton, subtitleIsNextToTitle }) => {
    const navigate = useNavigate();

    return (
        <div className={styles['content-block']}>
            <div className={styles['header-container']}>
                <div className={styles['title-container']}>
                    <h2 className={`${styles['title']} ${subtitleIsNextToTitle ? styles['with-subtitle'] : ''}`}>
                        {hasBackButton &&
                            <div className={styles['svg-container']} style={{width: '50px', height: '50px', cursor: 'pointer'}} onClick={() => {navigate(-1)}}>
                                <ArrowLeftSVG/>
                            </div>
                        }
                        {title}
                        {subtitleIsNextToTitle && subtitle &&
                            <span style={{color: "#BBBFC8", marginLeft: "10px"}}>{subtitle}</span>
                        }
                    </h2>
                    {subtitle && !subtitleIsNextToTitle &&
                        <p className={styles['sub-title']}>{subtitle}</p>
                    }
                </div>
            </div>
            <div className={styles['content-container']}>
                <div className={styles['inner-container']} style={{ zIndex: 1 }}>
                    {flap?.content}
                </div>
            </div>
        </div>
    );
};

export { SingleTabScreen };
